import {
  ChangeDetectionStrategy,
  Component,
  ViewEncapsulation,
} from '@angular/core';
import { I18nService } from '../../../../../core//services/i18n.service';
import { AlertService } from '../../../../../core/services/alert.service';
@Component({
  selector: 'app-jumbotron',
  templateUrl: './jumbotron.component.html',
  styleUrl: './jumbotron.component.scss',
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class JumbotronComponent {
  constructor(public alertService: AlertService, public i18nService: I18nService) { }
}